import { defineOperationManifest } from "../define"

export const menuDetectMetadataManifest = defineOperationManifest({
	type: "menu.detect-metadata",
	ability: "restaurant.menu::create",
	usageAbility: "ai.detect-allergens",
	bocLabelKey: "operations.boc.types.menuDetectMetadata",
})
